import { render, staticRenderFns } from "./FbaOpVerifyFrameDialog.vue?vue&type=template&id=6df15078&"
import script from "./FbaOpVerifyFrameDialog.vue?vue&type=script&lang=js&"
export * from "./FbaOpVerifyFrameDialog.vue?vue&type=script&lang=js&"
import style0 from "./FbaOpVerifyFrameDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df15078')) {
      api.createRecord('6df15078', component.options)
    } else {
      api.reload('6df15078', component.options)
    }
    module.hot.accept("./FbaOpVerifyFrameDialog.vue?vue&type=template&id=6df15078&", function () {
      api.rerender('6df15078', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/FBA/FbaOpVerifyFrameDialog.vue"
export default component.exports